// ハッシュタグ設定ファイル
// このファイルでハッシュタグを一元管理できます

export const hashtags = [
  'nakedinc'
];

// 必要に応じて言語別のハッシュタグも設定可能
export const hashtagsByLang = {
  ja: [
    'nakedinc'
  ],
  en: [
    'nakedinc'
  ]
};

// デフォルトのハッシュタグをエクスポート
export default hashtags;
